import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "staff-page" }
const _hoisted_2 = {
  key: 0,
  role: "alert",
  class: "ui-alert ui-alert--error mb-4"
}
const _hoisted_3 = {
  key: 1,
  class: "ui-empty"
}
const _hoisted_4 = {
  key: 2,
  class: "password-box"
}
const _hoisted_5 = { class: "password-text" }
const _hoisted_6 = {
  key: 0,
  class: "staff-toast",
  role: "status"
}

import { Card, CardHeader, CardTitle, CardContent, CardFooter } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';
import { Copy, RefreshCw, Check, X } from '@lucide/vue';

import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'Password',
  setup(__props) {

const password = ref<string | null>(null);
const loading = ref(true);
const error = ref<string | null>(null);
const showCopyNotification = ref(false);
let notificationTimer: ReturnType<typeof setTimeout> | null = null;
watch(showCopyNotification, (show) => {
  if (notificationTimer) clearTimeout(notificationTimer);
  if (show)
    notificationTimer = setTimeout(() => {
      showCopyNotification.value = false;
    }, 2000);
});
onBeforeUnmount(() => {
  if (notificationTimer) clearTimeout(notificationTimer);
});

function copyPassword() {
  if (password.value) {
    navigator.clipboard
      .writeText(password.value)
      .then(() => {
        showCopyNotification.value = true;
      })
      .catch((err) => {
        console.error('Не удалось скопировать пароль: ', err);
        error.value = 'Не удалось скопировать пароль. Пожалуйста, попробуйте вручную.';
      });
  }
}

async function fetchPassword() {
  loading.value = true;
  error.value = null;

  try {
    const response = await axios.get('/api/pass/');
    password.value = response.data;
  } catch (err) {
    console.error('Ошибка при получении пароля:', err);
    error.value = 'Не удалось получить пароль. Пожалуйста, попробуйте позже.';
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  fetchPassword();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("header", { class: "page-heading" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-eyebrow" }, "Аккаунт"),
        _createElementVNode("h1", null, "Мой пароль")
      ])
    ], -1)),
    _createVNode(_unref(Card), { class: "password-card max-w-xl" }, {
      default: _withCtx(() => [
        _createVNode(_unref(CardHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(CardTitle), null, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode("Одноразовый пароль", -1)
              ]))]),
              _: 1
            }),
            _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Действует в течение 24 часов", -1))
          ]),
          _: 1
        }),
        _createVNode(_unref(CardContent), null, {
          default: _withCtx(() => [
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true),
            (loading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(Spinner)),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Загрузка пароля…", -1))
                ]))
              : (password.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("code", _hoisted_5, _toDisplayString(password.value), 1),
                    _createVNode(_unref(Button), {
                      variant: "outline",
                      size: "icon",
                      class: "copy-icon-btn",
                      "aria-label": "Копировать пароль",
                      title: "Копировать пароль",
                      onClick: copyPassword
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Copy), { size: 18 })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_unref(CardFooter), { class: "justify-end" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Button), {
              variant: "outline",
              disabled: loading.value,
              onClick: fetchPassword
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(RefreshCw), { size: 16 }),
                _cache[4] || (_cache[4] = _createTextVNode(" Обновить пароль ", -1))
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (showCopyNotification.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_unref(Check), { size: 17 }),
          _cache[5] || (_cache[5] = _createTextVNode(" Пароль скопирован в буфер обмена ", -1)),
          _createVNode(_unref(Button), {
            variant: "ghost",
            size: "icon",
            "aria-label": "Закрыть уведомление",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showCopyNotification.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(X), { size: 16 })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})